import { Injectable } from '@angular/core';
import { Http, L10n, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { VatRateForSaleQuery, VatRateForSaleQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(VatRateForSaleQuery)
@Wrapper(VatRateForSaleQueryHandlerBase)
export class VatRateForSaleQueryHandler {
    public constructor(
        http: Http,
        l10n: L10n
    ) { }
}
